import { render, staticRenderFns } from "./MetaTemplateEditor.vue?vue&type=template&id=9c2d1e48&scoped=true"
import script from "./MetaTemplateEditor.vue?vue&type=script&lang=js"
export * from "./MetaTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./MetaTemplateEditor.vue?vue&type=style&index=0&id=9c2d1e48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2d1e48",
  null
  
)

export default component.exports